export const FETCH_INVESTMENTS = 'FETCH_INVESTMENTS';
export const FETCH_INVESTMENTS_SUMMARY = 'FETCH_INVESTMENTS_SUMMARY';
export const SET_INVESTMENTS = 'SET_INVESTMENTS';
export const SET_INVESTMENTS_SUMMARY = 'SET_INVESTMENTS_SUMMARY';

export const FETCH_INVESTMENTS_ANALYSIS = 'FETCH_INVESTMENTS_ANALYSIS';
export const SET_INVESTMENTS_ANALYSIS = 'SET_INVESTMENTS_ANALYSIS';
